import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Order Summary</h3><select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Today</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "donut",
              height: "295",
              options: _ctx.orderSummary,
              series: _ctx.summary
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled sales_by_locations style-two" }, [
        _createElementVNode("li", null, [
          _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Completed Order"),
          _createElementVNode("div", {
            class: "progress",
            role: "progressbar",
            "aria-label": "Success example",
            "aria-valuenow": "60",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "progress-bar bg-success",
              style: {"width":"60%"}
            }, [
              _createElementVNode("span", { class: "count fw-medium text-body" }, "60%")
            ])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "New Order"),
          _createElementVNode("div", {
            class: "progress",
            role: "progressbar",
            "aria-label": "Primary example",
            "aria-valuenow": "30",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "progress-bar bg-primary",
              style: {"width":"30%"}
            }, [
              _createElementVNode("span", { class: "count fw-medium text-body" }, "30%")
            ])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Pending Order"),
          _createElementVNode("div", {
            class: "progress",
            role: "progressbar",
            "aria-label": "Example with label",
            "aria-valuenow": "10",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("div", {
              class: "progress-bar bg-primary-div",
              style: {"width":"10%"}
            }, [
              _createElementVNode("span", { class: "count fw-medium text-body" }, "10%")
            ])
          ])
        ])
      ], -1))
    ])
  ]))
}